import React, { Component } from 'react';
import styled from 'styled-components';
import Mask from './Mask';

const Container = styled.div`

`

class Popup extends Component {
  constructor(props) {
    super(props);
    this.openMobileMenu = this._openMobileMenu.bind(this);
    this.closeMobileMenu = this._closeMobileMenu.bind(this);
  }

  _openMobileMenu() {
    if (document) {
      document.body.style.overflow = 'hidden';
      // document.body.style.position = 'fixed';
    }
    const { ifOpen, onHandlePopup } = this.props;
    if (!ifOpen) {
      onHandlePopup({
        ifOpen: true,
      })
    }
  }

  _closeMobileMenu() {
    const { ifOpen, onHandlePopup } = this.props;
    if (document) {
      document.body.style.overflow = null;
      document.body.style.position = null;
    }
    if (ifOpen) {
      onHandlePopup({
        ifOpen: false,
      })
    }
  }

  componentDidMount() {
    const { ifOpen } = this.props;
    if (ifOpen) {
      this._openMobileMenu();
    } else {
      this._closeMobileMenu();
    }
  }

  componentDidUpdate() {
    const { ifOpen } = this.props;
    if (ifOpen) {
      this._openMobileMenu();
    } else {
      this._closeMobileMenu();
    }
  }

  render() {
    const { Content, ifOpen } = this.props;
    if (!ifOpen) {
      return null;
    }
    return (
      <Container>
        <Mask
          ifOpen={ifOpen}
          closeMobileMenu={this.closeMobileMenu}
          Content={Content}
        />
      </Container>
    );
  }
}

export default Popup;
